export const mockData = {
  automationHelp: {
    description: "Most small businesses lose 20-30 hours per week on manual, repetitive tasks that drain productivity and limit growth. We audit your current workflows and implement intelligent automation solutions that eliminate busywork, reduce errors, and accelerate your business processes—giving you a competitive edge while cutting operational costs."
  },
  
  teams: [
    {
      id: "sales",
      name: "Sales",
      automations: [
        {
          title: "New Lead Follow-Up",
          description: "Automated lead nurturing and qualification system",
          accentColor: "accent-purple",
          before: "Sales rep manually processes website forms, enters leads into CRM, sends welcome emails, and schedules follow-ups. 15 minutes per lead means fewer prospects contacted and slower response times hurt conversion rates.",
          after: "Leads are instantly captured, enriched with company data, and entered into personalized nurture sequences. Sales reps get qualified lead summaries in 30 seconds, enabling immediate high-value conversations that close more deals."
        },
        {
          title: "Quote Follow-Up",
          description: "Intelligent quote tracking and follow-up automation",
          accentColor: "accent-blue",
          before: "Sales reps manually track quote deadlines and send follow-ups, often missing opportunities. Delayed or forgotten follow-ups mean losing deals to competitors and revenue slipping through the cracks.",
          after: "Intelligent follow-up sequences keep prospects engaged with timely reminders. Real-time engagement tracking shows when prospects view quotes, enabling sales reps to call at the perfect moment and close more deals faster."
        }
      ]
    },
    {
      id: "hr",
      name: "HR & Admin",
      automations: [
        {
          title: "Employee Onboarding",
          description: "Streamlined new hire process automation",
          accentColor: "accent-green",
          before: "HR manually sends paperwork, tracks completion, schedules training sessions, and coordinates with IT for system access. This takes 4-6 hours per new hire.",
          after: "New hires receive personalized onboarding workflows with automated document collection, training scheduling, and system provisioning, reducing HR time to 1 hour per hire."
        },
        {
          title: "Time Off Management",
          description: "Automated vacation and PTO tracking",
          accentColor: "accent-orange",
          before: "Employees email requests, managers manually track approvals, and HR updates spreadsheets. Coverage gaps and scheduling conflicts are common.",
          after: "Self-service portal handles requests, automatic approval workflows, calendar integration, and team notifications ensure smooth operations and no coverage gaps."
        }
      ]
    },
    {
      id: "operations",
      name: "Operations",
      automations: [
        {
          title: "Inventory Management",
          description: "Smart inventory tracking and reordering",
          accentColor: "accent-pink",
          before: "Manual inventory counts, spreadsheet tracking, and reactive ordering lead to stockouts or overstock situations costing thousands monthly.",
          after: "Automated inventory monitoring with predictive reordering prevents stockouts, optimizes cash flow, and reduces carrying costs by 20-40%."
        },
        {
          title: "Invoice Processing",
          description: "Automated accounts payable workflow",
          accentColor: "accent-grey",
          before: "Manual data entry from paper invoices, approval routing via email, and check writing takes 15-20 minutes per invoice with frequent errors.",
          after: "OCR captures invoice data automatically, smart routing for approvals, and integrated payments reduce processing time to 2 minutes per invoice with 99% accuracy."
        }
      ]
    },
    {
      id: "marketing",
      name: "Marketing",
      automations: [
        {
          title: "Social Media Management",
          description: "Automated content scheduling and engagement",
          accentColor: "accent-blue",
          before: "Daily manual posting across platforms, inconsistent messaging, and reactive customer service responses hurt brand presence and engagement.",
          after: "Content calendar automation, brand-consistent messaging, and automated response workflows maintain strong social presence while freeing 10+ hours weekly."
        },
        {
          title: "Email Campaigns",
          description: "Personalized email marketing automation",
          accentColor: "accent-purple",
          before: "Batch-and-blast emails with poor targeting result in low open rates, high unsubscribe rates, and missed revenue opportunities.",
          after: "Behavioral triggers, personalized content, and automated segmentation increase open rates 40% and generate 25% more revenue per subscriber."
        }
      ]
    },
    {
      id: "customer",
      name: "Customer Service",
      automations: [
        {
          title: "Support Ticket Routing",
          description: "Intelligent customer inquiry management",
          accentColor: "accent-green",
          before: "All support requests go to one inbox, causing delays, missed inquiries, and frustrated customers waiting days for responses.",
          after: "Smart routing by inquiry type, automated responses for common questions, and escalation workflows ensure 2-hour response times and higher satisfaction."
        },
        {
          title: "Customer Onboarding",
          description: "Automated new customer welcome process",
          accentColor: "accent-orange",
          before: "Manual welcome calls, document sharing via email, and inconsistent onboarding experiences lead to confused customers and higher churn.",
          after: "Personalized welcome sequences, self-service resource portals, and automated check-ins create consistent experiences and reduce churn by 30%."
        }
      ]
    },
    {
      id: "more",
      name: "More",
      automations: [
        {
          title: "Financial Reporting",
          description: "Automated business intelligence dashboards",
          accentColor: "accent-pink",
          before: "Manual report generation from multiple systems takes days, provides outdated information, and limits strategic decision-making ability.",
          after: "Real-time dashboards aggregate data automatically, provide instant insights, and enable data-driven decisions that improve profitability by 15-25%."
        },
        {
          title: "Compliance Management",
          description: "Automated regulatory compliance tracking",
          accentColor: "accent-grey",
          before: "Manual tracking of deadlines, document updates, and audit preparation creates compliance risks and consumes significant administrative time.",
          after: "Automated compliance calendars, document management, and audit trail generation ensure 100% compliance while reducing administrative overhead by 60%."
        }
      ]
    }
  ],
  
  results: [
    {
      metric: "20-30 Hours",
      title: "Weekly Time Saved",
      description: "Average time reclaimed per week through automation implementation"
    },
    {
      metric: "50-80% Faster",
      title: "Process Speed",
      description: "Typical improvement in workflow completion times"
    },
    {
      metric: "90% Fewer",
      title: "Manual Errors",
      description: "Reduction in human error rates through automation"
    },
    {
      metric: "2-4 Months",
      title: "ROI Timeline",
      description: "Time to see full return on automation investment"
    }
  ]
};